import DatePicker from 'react-datepicker';
import React from 'react'
import "react-datepicker/dist/react-datepicker.css";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

const BranchOfferConfigTable = (props) => {
  let { offer, setOffer } = props;

  const changeConfig = (e, field_name, index) => {
      switch(field_name) {
        case 'present_cashback':
          setOffer((prevState)=>{
            return { ...prevState,
              branch_offer_configs: prevState.branch_offer_configs.map((config, curr_index)=> {
              if(index === curr_index) {
                config["config"]["present_cashback"] = config['config']["present_cashback"] || {}
                config["config"]["present_cashback"]["amount"] = e.target.value
              }
              return { ...config }
            })}
          })
          break;
        case 'absent_penalty':
          setOffer((prevState)=>{
            return { ...prevState,
              branch_offer_configs: prevState.branch_offer_configs.map((config, curr_index)=> {
              if(index === curr_index) {
                config['config']["absent_penalty"] = config['config']["absent_penalty"] || {}
                config['config']["absent_penalty"]["amount"] = e.target.value
              }
              return { ...config }
            })}
          })
          break;
        case 'start_date':
          setOffer((prevState)=>{
            return { ...prevState,
              branch_offer_configs: prevState.branch_offer_configs.map((config, curr_index)=> {
              if(index === curr_index) {
                config['config']["present_cashback"] = config['config']["present_cashback"] || {}
                config['config']["absent_penalty"] = config['config']["absent_penalty"] || {}

                config['config']["present_cashback"]["start_date"] = new Date(e)
                config['config']["absent_penalty"]["start_date"] = new Date(e)
              }
              return { ...config }
            })}
          })
          break;
        case 'end_date':
          setOffer((prevState)=>{
            return { ...prevState,
              branch_offer_configs: prevState.branch_offer_configs.map((config, curr_index)=> {
              if(index === curr_index) {
                config['config']["present_cashback"] = config['config']["present_cashback"] || {}
                config['config']["absent_penalty"] = config['config']["absent_penalty"] || {}
                
                config['config']["present_cashback"]["end_date"] = new Date(e)
                config['config']["absent_penalty"]["end_date"] = new Date(e)
              }
              return { ...config }
            })}
          })
          break;
          default:
          break;
      }
    }

  const createRow = (config_item, index) => {
    let config_item_data = config_item?.config;
    const disabled = offer.branches.map((branch)=> branch.id).includes(config_item.branch_id) ? false : true;
    return <tr key={index}>
      <td className={disabled ? 'text-warning' : ""}>{props.branch_id_map[config_item.branch_id]}</td>
      <td>
        <input
          disabled={disabled}
          className="form-control form-control-sm font-size-12"
          type="number"
          placeholder="Enter present cashback Amount"
          value={config_item.config?.present_cashback?.amount}
          onChange={(e)=>{changeConfig(e, 'present_cashback', index)}}/>
      </td>
      <td>
        <input
          disabled={disabled}
          className="form-control form-control-sm font-size-12"
          type="number"
          placeholder="Enter absent penalty Amount"
          value={config_item.config?.absent_penalty?.amount}
          onChange={(e)=>{changeConfig(e, 'absent_penalty', index)}}/>
      </td>
      <td>
        <DatePicker
          disabled={disabled}
          selected={new Date(config_item_data?.present_cashback?.start_date)}
          dateFormat='dd/MM/yyyy'
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          onChange={(e) => changeConfig(e, 'start_date', index)}
          placeholderText="Select From Date"
          className="font-size-12"
        />
      </td>
      <td>
        <DatePicker
          disabled={disabled}
          selected={new Date(config_item_data.present_cashback?.end_date)}
          dateFormat='dd/MM/yyyy'
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          onChange={(e) => changeConfig(e, 'end_date', index)}
          placeholderText="Select From Date"
          className="font-size-12"
          minDate={new Date(config_item_data.present_cashback?.end_date)}
        />
      </td>
    </tr>
  }

  return <>
  {offer.branch_offer_configs.length === 0 ? <></> :
    <div className='mt-4'>
      <div className='d-flex'>
        <h6 className='text-success'>Penalty and Cashback Configuration</h6>
        <OverlayTrigger
          placement="top"
          delay={{ show: 250, hide: 400}}
          overlay={(props) =>
            <Tooltip id="field-ifo-tooltip" {...props} style={{ ...props.style, fontSize: "14px" }}>
              <strong>Map the offer to a new circle to create a new penalty and cashback configuration.</strong>
            </Tooltip>
          }
        >
          <FontAwesomeIcon
            className="icon ms-2"
            icon={faInfoCircle}
            style={{ cursor: 'pointer', color: 'green', width: '15px', height: '15px', paddingTop: '2px' }}
          />
        </OverlayTrigger>
      </div>
      <table className="table">
        <thead>
          <tr>
            <th scope="col">Branch</th>
            <th scope="col">Present Cashback</th>
            <th scope="col">Absent Penalty</th>
            <th scope="col">Start Date</th>
            <th scope="col">End Date</th>
          </tr>
        </thead>
        <tbody>
          {offer.branch_offer_configs.map((config_item, index)=>{
            return createRow(config_item, index);
          })}
        </tbody>
      </table>
    </div>
  }
  </>
};

export default BranchOfferConfigTable;
